import groupBy from "lodash/groupBy"
import { Template } from "@easy-templates/types"

import SectionMessage from "components/ui/SectionMessage"
import Select from "components/Select"
import Variables from "components/Variables"
import Labeled from "components/Field/Labeled"
import { ProgressTracker } from "components/ui/progress-tracker"
import CreationProgress from "components/ui/progress"
import StructureSelector from "components/structure-selector"
import IconText from "components/ui/IconText"


import {
  filterProject,
  // filterIssuetype,
  filterTemplate,
} from "./filters"

import { TemplateHint, ProjectHint } from "./Hints"
import ValidationError from "./ValidationError"
import StepInfo from './step-info'
import { StepPage } from "./useHandlers/types"

const Form = ({
  creationResults,
  errorMessage,
  fullSelectedTemplate,
  handleProjectChange,
  handleTemplateChange,
  handleIssuesChange,
  isPrefilling,
  isSubmitting,
  isDisabled,
  missingFields,
  projects,
  selectedIssueType,
  selectedProject,
  selectedTemplate,
  selectedIssueIds,
  steps,
  currentStep,
  templates,
  variables,
  warnings,
}) => {
  const templateOptions = Object.entries<Template[]>(
    groupBy(templates, "issuetype.name")
  ).map(([issuetypeName, templates]) => {
    return {
      label: issuetypeName,
      options: templates.map((template) => ({
        ...template,
        iconUrl: template.issuetype.iconUrl,
      })),
    }
  })

  return (
    <>
      <div
        data-testid="create-from-template-selects"
        style={{ paddingBottom: 8 }}
      >
        <ProgressTracker items={steps} />
        {currentStep === StepPage.SELECT && (
          <>
            <StepInfo gutterTop>
              Select a project and a template
            </StepInfo>

            <Labeled name="project" label="Project" hint={<ProjectHint />}>
              <Select
                // @ts-ignore
                onChange={handleProjectChange}
                value={selectedProject}
                options={projects}
                placeholder="Choose a Project"
                filterOption={filterProject}
                isDisabled={isDisabled || isSubmitting}
                classNamePrefix="project-field"
              />
            </Labeled>
            <Labeled name="template" label="Template" hint={<TemplateHint />}>
              <Select
                // @ts-ignore
                onChange={handleTemplateChange}
                value={selectedTemplate}
                options={templateOptions}
                placeholder="Choose a Template"
                isDisabled={isDisabled || !selectedIssueType || isSubmitting}
                filterOption={filterTemplate}
                classNamePrefix="template-field"
              />
            </Labeled>
            {!!missingFields.length && (
              <ValidationError fields={missingFields} />
            )}
          </>
        )}
        {currentStep === StepPage.REVIEW && fullSelectedTemplate && (
          <>
            <StepInfo gutterTop>
              Select issues to create
            </StepInfo>
            <br />
            <IconText iconUrl={fullSelectedTemplate.issuetype.iconUrl}>
              {fullSelectedTemplate.issues[fullSelectedTemplate.rootIssueId].name}
            </IconText>
            <StructureSelector
              tree={fullSelectedTemplate.tree}
              issues={fullSelectedTemplate.issues}
              selectedIds={selectedIssueIds}
              disabledIds={[fullSelectedTemplate.rootIssueId]}
              onChange={handleIssuesChange}
            />
          </>
        )}
        {/* Keep it mounted but hidden in order the form reference to remain */}
        {currentStep === StepPage.FILL && (
          <StepInfo gutterBottom gutterTop>
            Fill in the form
          </StepInfo>
        )}
        <Variables
          isHidden={currentStep !== StepPage.FILL}
          variables={variables}
          isDisabled={isSubmitting || isPrefilling}
        />
        {currentStep === StepPage.RESULT && (
          <div style={{ paddingTop: 24 }}>
            <CreationProgress items={creationResults} />
          </div>
        )}
      </div>
      {errorMessage && (
        <SectionMessage appearance="error">
          <p>{errorMessage}</p>
        </SectionMessage>
      )}
      {warnings.length > 0 && (
        <SectionMessage appearance="warning">
          {warnings.map((warning: string) => (
            <div>{warning}</div>
          ))}
        </SectionMessage>
      )}
    </>
  )
}

export default Form
